import React from 'react';

import classes from './Input.module.css';

const Input = (props) => {
	let inputElement = null;
	const inputElementClasses = [classes.InputElement];
	let errorMessage;
	if (props.invalid && props.isTouched) {
		inputElementClasses.push(classes.Invalid);
		errorMessage = <small>{props.errorMessage}</small>;
	}

	switch (props.elementType) {
		case 'input':
			inputElement = (
				<input
					className={inputElementClasses.join(' ')}
					{...props.elementConfig}
					value={props.value}
					onChange={props.changed}
				/>
			);
			break;
		case 'textarea':
			inputElement = (
				<textarea
					className={inputElementClasses.join(' ')}
					{...props.elementConfig}
					value={props.value}
					onChange={props.changed}
				/>
			);
			break;
		case 'select':
			inputElement = (
				<select
					className={inputElementClasses.join(' ')}
					value={props.value}
					onChange={props.changed}
				>
					{props.elementConfig.options.map((option) => (
						<option key={option.value} value={option.value}>
							{option.displayValue}
						</option>
					))}
				</select>
			);
			break;
		default:
			inputElement = (
				<input
					className={inputElementClasses.join(' ')}
					{...props.elementConfig}
					value={props.value}
					onChange={props.changed}
				/>
			);
	}

	return (
		<div className={classes.Input}>
			<label className={classes.Label}>{props.label}</label>
			{inputElement}
			{errorMessage ? (
				<p className={classes.ErrorMessage}>{errorMessage}</p>
			) : null}
		</div>
	);
};

export default Input;
